import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as jobReducer from "containers/Job/reducer";

import { getScores } from "containers/Deploy/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ModelTile from "components/Tiles/Model/ModelTile";
import ModelTileContest from "components/Tiles/Model/ModelTileContest";
import ModelTileSuccess from "components/Tiles/Model/ModelTileSuccess";
import ModelTileFix from "components/Tiles/Model/ModelTileFix";
import ModelTileRight from "components/Tiles/Model/ModelTileRight";

class ModelTileContainer extends React.PureComponent {
  render() {
    const {
      id,
      model,
      models,
      payload,
      isContest,
      isSuccess,
      isFix,
      isRightPanel,
      updateDeploy,
      updateFeatureSelection,
      history
    } = this.props;

    if (model === undefined && (payload === undefined || payload.length === 0)) {
      return <LoadingIndicator />;
    }

    return isContest ? (
      <ModelTileContest
        {...this.props}
        onClick={() => updateDeploy(model.id)}
        model={
          model
            ? model
            : payload && payload.length > 0
              ? models.filter((m) => m.id === payload[0].payload.model.id)[0]
              : undefined
        }
      />
    ) : isSuccess ? (
      <ModelTileSuccess
        {...this.props}
        onClick={() => updateFeatureSelection(model.id)}
        model={
          model
            ? model
            : payload && payload.length > 0 && models
              ? models.filter((m) => m.id === payload[0].payload.model.id)[0]
              : undefined
        }
      />
    ) : isFix ? (
      <ModelTileFix
        {...this.props}
        onClick={() => {}}
        model={
          model
            ? model
            : payload && payload.length > 0 && models
              ? models.filter((m) => m.id === payload[0].payload.model.id)[0]
              : undefined
        }
      />
    ) : isRightPanel ? (
      <ModelTileRight
        {...this.props}
        onClick={() => {}}
        model={
          model
            ? model
            : payload && payload.length > 0 && models
              ? models.filter((m) => m.id === payload[0].payload.model.id)[0]
              : undefined
        }
      />
    ) : (
      <ModelTile
        {...this.props}
        onClick={() => history.push("/deploy/" + id + "/" + model.id)}
        model={
          model
            ? model
            : payload && payload.length > 0
              ? models.filter((m) => m.id === payload[0].payload.model.id)[0]
              : undefined
        }
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFeatureSelection: (modelId) => dispatch(runReducer.updateFeatureSelection(ownProps.id, modelId)),
  updateDeploy: (id) => dispatch(runReducer.updateDeploy(ownProps.id, id)),
  updateLeftKey: (key) => dispatch(jobReducer.updateLeftKey(key)),
  updateRightKey: (key) => dispatch(jobReducer.updateRightKey(key))
});

const mapStateToProps = (state, ownProps) => {
  return {
    hideCosts: false && setupReducer.getHideCosts(state, ownProps.id),
    processLimit: setupReducer.getProcessLimit(state, ownProps.id),

    truePositiveLabel: setupReducer.getTruePositiveLabel(state, ownProps.id),
    falsePositiveLabel: setupReducer.getFalsePositiveLabel(state, ownProps.id),
    trueNegativeLabel: setupReducer.getTrueNegativeLabel(state, ownProps.id),
    falseNegativeLabel: setupReducer.getFalseNegativeLabel(state, ownProps.id),

    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, ownProps.id),

    scoreCount:
      ownProps.model && getScores(state, ownProps.id, ownProps.model.id)
        ? Object.keys(getScores(state, ownProps.id, ownProps.model.id)).length
        : 0,

    isFeatured: ownProps.model ? runReducer.getFeatureSelection(state, ownProps.id, true) === ownProps.model.id : false,

    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),

    trueAction: setupReducer.getTrueAction(state, ownProps.id),
    falseAction: setupReducer.getFalseAction(state, ownProps.id),

    aucData: ownProps.model ? runReducer.getAUCData(state, ownProps.id, ownProps.model.id) : undefined,

    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isForceOptimized: setupReducer.getIsForceOptimized(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelTileContainer);
